import { render, staticRenderFns } from "./ReorderArray.vue?vue&type=template&id=06515158&scoped=true"
import script from "./ReorderArray.vue?vue&type=script&lang=js"
export * from "./ReorderArray.vue?vue&type=script&lang=js"
import style0 from "./ReorderArray.vue?vue&type=style&index=0&id=06515158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06515158",
  null
  
)

export default component.exports